import { unsafeCSS as w, LitElement as C, html as b } from "lit";
import { property as n } from "lit/decorators.js";
const S = (e) => {
  class o extends e {
    constructor(...l) {
      super(...l), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const t = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(t.getElementsByTagName("link")).findIndex(
        (p) => p.href === this.fontLink
      ) === -1) {
        const p = document.createElement("link");
        p.href = this.fontLink, p.rel = "stylesheet", document.head.appendChild(p);
      }
    }
  }
  return o;
}, P = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.inline{display:inline}.flex{display:flex}.table{display:table}.grid{display:grid}[hidden]{display:none!important}', A = w(P), u = "aileron-color-scheme", v = "aileron-color-scheme-change", L = (e) => {
  const a = class a extends e {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (t) => {
        t.detail ? this.setAttribute(u, t.detail) : this.removeAttribute(u);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        v,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const t = document.documentElement.getAttribute(
        u
      );
      t && this.setAttribute(u, t);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        v,
        this.handleSchemeSwitch
      );
    }
  };
  a.styles = [
    A,
    e.styles ?? []
  ];
  let o = a;
  return o;
}, d = L(S(C)), z = (e, o, a) => Array.prototype.forEach.call(e, o, a), g = ':host(.focus-visible),:host(:focus-within){outline:0}:host(.adc-grid){display:block;flex-grow:1;margin:0;box-sizing:border-box;width:100%}:host(.adc-grid[reverse]) ::slotted(.adc-row){flex-direction:row-reverse}:host(.adc-grid[flush]){margin-left:.25rem;margin-right:.25rem}:host(.adc-grid[form]) ::slotted(.adc-row){align-items:flex-start}:host(.adc-grid[position="start"]){justify-content:flex-start}:host(.adc-grid[position="center"]){justify-content:center}:host(.adc-grid[position="end"]){justify-content:flex-end}@media (min-width: 1440px){:host(.adc-grid){max-width:1216px;width:100%;margin:0 auto}:host(.adc-grid[nested]){width:100%}}:host(.adc-row){display:flex;flex-wrap:wrap;margin-left:-1rem;margin-right:-1rem}:host(.adc-row[has-form]) ::slotted(.adc-column){margin-bottom:2rem}:host(.adc-row[flush]) ::slotted(.adc-column){padding-left:0;padding-right:0}:host(.adc-column){display:block;padding-left:1rem;padding-right:1rem;width:100%;flex-basis:0;flex-grow:1;max-width:100%;box-sizing:border-box}:host(.adc-column[col-phone="1"]){display:block;flex:0 0 25%;max-width:25%}:host(.adc-column[col-phone-offset="1"]){margin-left:25%}:host(.adc-column[col-phone="2"]){display:block;flex:0 0 50%;max-width:50%}:host(.adc-column[col-phone-offset="2"]){margin-left:50%}:host(.adc-column[col-phone="3"]){display:block;flex:0 0 75%;max-width:75%}:host(.adc-column[col-phone-offset="3"]){margin-left:75%}:host(.adc-column[col-phone="4"]){display:block;flex:0 0 100%;max-width:100%}:host(.adc-column[col-phone-offset="4"]){margin-left:100%}@media (min-width: 800px){:host(.adc-column[col-tablet="1"]){display:block;flex:0 0 12.5%;max-width:12.5%}:host(.adc-column[col-tablet-offset="1"]){margin-left:12.5%}:host(.adc-column[col-tablet="2"]){display:block;flex:0 0 25%;max-width:25%}:host(.adc-column[col-tablet-offset="2"]){margin-left:25%}:host(.adc-column[col-tablet="3"]){display:block;flex:0 0 37.5%;max-width:37.5%}:host(.adc-column[col-tablet-offset="3"]){margin-left:37.5%}:host(.adc-column[col-tablet="4"]){display:block;flex:0 0 50%;max-width:50%}:host(.adc-column[col-tablet-offset="4"]){margin-left:50%}:host(.adc-column[col-tablet="5"]){display:block;flex:0 0 62.5%;max-width:62.5%}:host(.adc-column[col-tablet-offset="5"]){margin-left:62.5%}:host(.adc-column[col-tablet="6"]){display:block;flex:0 0 75%;max-width:75%}:host(.adc-column[col-tablet-offset="6"]){margin-left:75%}:host(.adc-column[col-tablet="7"]){display:block;flex:0 0 87.5%;max-width:87.5%}:host(.adc-column[col-tablet-offset="7"]){margin-left:87.5%}:host(.adc-column[col-tablet="8"]){display:block;flex:0 0 100%;max-width:100%}:host(.adc-column[col-tablet-offset="8"]){margin-left:100%}}@media (min-width: 1280px){:host(.adc-column[col-desktop="1"]){display:block;flex:0 0 calc(100% / (12 / 1));max-width:calc(100% / (12 / 1))}:host(.adc-column[col-desktop-offset="1"]){margin-left:calc(100% / (12 / 1))}:host(.adc-column[col-desktop="2"]){display:block;flex:0 0 calc(100% / (12 / 2));max-width:calc(100% / (12 / 2))}:host(.adc-column[col-desktop-offset="2"]){margin-left:calc(100% / (12 / 2))}:host(.adc-column[col-desktop="3"]){display:block;flex:0 0 25%;max-width:25%}:host(.adc-column[col-desktop-offset="3"]){margin-left:25%}:host(.adc-column[col-desktop="4"]){display:block;flex:0 0 calc(100% / (12 / 4));max-width:calc(100% / (12 / 4))}:host(.adc-column[col-desktop-offset="4"]){margin-left:calc(100% / (12 / 4))}:host(.adc-column[col-desktop="5"]){display:block;flex:0 0 calc(100% / (12 / 5));max-width:calc(100% / (12 / 5))}:host(.adc-column[col-desktop-offset="5"]){margin-left:calc(100% / (12 / 5))}:host(.adc-column[col-desktop="6"]){display:block;flex:0 0 50%;max-width:50%}:host(.adc-column[col-desktop-offset="6"]){margin-left:50%}:host(.adc-column[col-desktop="7"]){display:block;flex:0 0 calc(100% / (12 / 7));max-width:calc(100% / (12 / 7))}:host(.adc-column[col-desktop-offset="7"]){margin-left:calc(100% / (12 / 7))}:host(.adc-column[col-desktop="8"]){display:block;flex:0 0 calc(100% / (12 / 8));max-width:calc(100% / (12 / 8))}:host(.adc-column[col-desktop-offset="8"]){margin-left:calc(100% / (12 / 8))}:host(.adc-column[col-desktop="9"]){display:block;flex:0 0 75%;max-width:75%}:host(.adc-column[col-desktop-offset="9"]){margin-left:75%}:host(.adc-column[col-desktop="10"]){display:block;flex:0 0 calc(100% / (12 / 10));max-width:calc(100% / (12 / 10))}:host(.adc-column[col-desktop-offset="10"]){margin-left:calc(100% / (12 / 10))}:host(.adc-column[col-desktop="11"]){display:block;flex:0 0 calc(100% / (12 / 11));max-width:calc(100% / (12 / 11))}:host(.adc-column[col-desktop-offset="11"]){margin-left:calc(100% / (12 / 11))}:host(.adc-column[col-desktop="12"]){display:block;flex:0 0 100%;max-width:100%}:host(.adc-column[col-desktop-offset="12"]){margin-left:100%}}';
var N = Object.defineProperty, f = (e, o, a, l) => {
  for (var t = void 0, i = e.length - 1, r; i >= 0; i--)
    (r = e[i]) && (t = r(o, a, t) || t);
  return t && N(o, a, t), t;
};
const F = {
  START: "start",
  END: "end",
  CENTER: "center",
  EMPTY: ""
}, y = class y extends d {
  constructor() {
    super(...arguments), this.position = F.EMPTY, this.reverse = !1, this.flush = !1, this.form = !1, this.nested = !1;
  }
  render() {
    return b`<slot></slot>`;
  }
  /**
   * If the parent DOM node is an adc-column, then it is a nested grid.
   */
  connectedCallback() {
    this.classList.add("adc-grid"), super.connectedCallback(), this.closest(".adc-column") && (this.nested = !0);
  }
  updated(o) {
    const { selectorGridRow: a } = this.constructor;
    if (o.has("reverse")) {
      const { reverse: l } = this;
      z(this.querySelectorAll(a), (t) => {
        t.reverse = l;
      });
    }
    if (o.has("form")) {
      const { form: l } = this;
      z(this.querySelectorAll(a), (t) => {
        t.hasForm = l;
      });
    }
  }
  /**
   * @private
   */
  static get selectorGridRow() {
    return ".adc-row";
  }
};
y.styles = [d.styles || [], w(g)];
let c = y;
f([
  n({ type: String })
], c.prototype, "position");
f([
  n({ type: Boolean, reflect: !0 })
], c.prototype, "reverse");
f([
  n({ type: Boolean, reflect: !0 })
], c.prototype, "flush");
f([
  n({ type: Boolean, reflect: !0 })
], c.prototype, "form");
f([
  n({ type: Boolean, reflect: !0 })
], c.prototype, "nested");
try {
  customElements.define("adc-grid", c), console.warn(
    "@aileron/grid is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/grid"
  );
} catch {
}
function O(e) {
  try {
    customElements.define(`${e}-grid`, class extends c {
    });
  } catch {
  }
}
var T = Object.defineProperty, m = (e, o, a, l) => {
  for (var t = void 0, i = e.length - 1, r; i >= 0; i--)
    (r = e[i]) && (t = r(o, a, t) || t);
  return t && T(o, a, t), t;
};
const x = class x extends d {
  constructor() {
    super(...arguments), this.colDesktop = 0, this.colTablet = 0, this.colPhone = 0, this.colDesktopOffset = 0, this.colTabletOffset = 0, this.colPhoneOffset = 0;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-column");
  }
  render() {
    return b`<slot></slot>`;
  }
};
x.styles = [d.styles || [], w(g)];
let s = x;
m([
  n({ attribute: "col-desktop", type: Number })
], s.prototype, "colDesktop");
m([
  n({ attribute: "col-tablet", type: Number })
], s.prototype, "colTablet");
m([
  n({ attribute: "col-phone", type: Number })
], s.prototype, "colPhone");
m([
  n({ attribute: "col-desktop-offset", type: Number })
], s.prototype, "colDesktopOffset");
m([
  n({ attribute: "col-tablet-offset", type: Number })
], s.prototype, "colTabletOffset");
m([
  n({ attribute: "col-phone-offset", type: Number })
], s.prototype, "colPhoneOffset");
try {
  customElements.define("adc-column", s), console.warn("@aileron/grid is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/grid");
} catch {
}
function _(e) {
  try {
    customElements.define(`${e}-column`, class extends s {
    });
  } catch {
  }
}
var j = Object.defineProperty, E = (e, o, a, l) => {
  for (var t = void 0, i = e.length - 1, r; i >= 0; i--)
    (r = e[i]) && (t = r(o, a, t) || t);
  return t && j(o, a, t), t;
};
const k = class k extends d {
  constructor() {
    super(...arguments), this.hasForm = !1, this.reverse = !1;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-row");
  }
  render() {
    return b`<slot></slot>`;
  }
};
k.styles = [d.styles || [], w(g)];
let h = k;
E([
  n({ type: Boolean, reflect: !0, attribute: "has-form" })
], h.prototype, "hasForm");
E([
  n({ type: Boolean, reflect: !0 })
], h.prototype, "reverse");
try {
  customElements.define("adc-row", h), console.warn("@aileron/grid is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/grid");
} catch {
}
function B(e) {
  try {
    customElements.define(`${e}-row`, class extends h {
    });
  } catch {
  }
}
function D(e) {
  try {
    _(e), O(e), B(e);
  } catch {
  }
}
export {
  s as Column,
  F as GRID_POSITION,
  c as Grid,
  h as Row,
  _ as registerColumn,
  D as registerComponent,
  O as registerGrid,
  B as registerRow
};
